import italic from "../styles/BuckeyeSans/BuckeyeSans2-Italic.woff2"
import regular from "../styles/BuckeyeSans/BuckeyeSans2-Regular.woff2"
import semiBold from "../styles/BuckeyeSans/BuckeyeSans2-SemiBold.woff2"
import semiBoldItalic from "../styles/BuckeyeSans/BuckeyeSans2-SemiBoldItalic.woff2"
import bold from "../styles/BuckeyeSans/BuckeyeSans2-Bold.woff2"
import boldItalic from "../styles/BuckeyeSans/BuckeyeSans2-BoldItalic.woff2"
import black from "../styles/BuckeyeSans/BuckeyeSans2-Black.woff2"
import blackItalic from "../styles/BuckeyeSans/BuckeyeSans2-BlackItalic.woff2"
import extraBold from "../styles/BuckeyeSans/BuckeyeSans2-ExtraBold.woff2"
import extraBoldItalic from "../styles/BuckeyeSans/BuckeyeSans2-ExtraBoldItalic.woff2"

export const fontWeights = {
  regular: 400,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
}

const fonts = [
  {
    url: italic,
    weight: fontWeights.regular,
    style: "italic",
  },
  {
    url: regular,
    weight: fontWeights.regular,
    style: "normal",
  },
  {
    url: semiBold,
    weight: fontWeights.semiBold,
    style: "normal",
  },
  {
    url: semiBoldItalic,
    weight: fontWeights.semiBold,
    style: "italic",
  },
  {
    url: bold,
    weight: fontWeights.bold,
    style: "normal",
  },
  {
    url: boldItalic,
    weight: fontWeights.bold,
    style: "italic",
  },
  {
    url: extraBold,
    weight: fontWeights.extraBold,
    style: "normal",
  },
  {
    url: extraBoldItalic,
    weight: fontWeights.extraBold,
    style: "italic",
  },
  {
    url: black,
    weight: fontWeights.black,
    style: "normal",
  },
  {
    url: blackItalic,
    weight: fontWeights.black,
    style: "italic",
  }
];
let fontFace = "";

fonts.forEach(({ url, weight, style }) => {
  fontFace += `
        @font-face {
            font-family: 'BuckeyeSans';
            font-style: ${style};
            font-display: fallback;
            font-weight: ${weight};
            src: url(${url}) format('woff2');
        }
    `;
});

export default fontFace;
